"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosVendor = void 0;
var PosVendor;
(function (PosVendor) {
    /**
     * PAR Brink POS
     * https://brinkapiportal.brinkpos.net
     */
    PosVendor["BRINK"] = "BRINK";
    /**
     * Xenial XOO integration specific to the Carrols BK frachise group.
     */
    PosVendor["CARROLS"] = "CARROLS";
    /**
     * @deprecated - use PRODUCT_NUMBER instead
     *
     * IMPORTANT: DO NOT USE THE "CONNECTOR" PosVendor!
     */
    PosVendor["CONNECTOR"] = "CONNECTOR";
    /**
     * National Cash Register (NCR) / and NCR Enterprise Platform (NEP)
     */
    PosVendor["NCR"] = "NCR";
    /**
     * Oracle Hospitality eCommerce Integration Cloud Service (OHEICS)
     * also known as Oracle
     * also know as Micros
     */
    PosVendor["OHEICS"] = "OHEICS";
    /**
     * Used for Partner API to allow 3rd parties to integrate with us
     */
    PosVendor["PARTNER"] = "PARTNER";
    /**
     * Tim Horton's Connector (a.k.a Product Number)
     */
    PosVendor["PRODUCT_NUMBER"] = "PRODUCT_NUMBER";
    /**
     * rPOS / RBI POS (f.k.a. MediaWorks)
     */
    PosVendor["RPOS"] = "RPOS";
    PosVendor["SIMPLY_DELIVERY"] = "SIMPLY_DELIVERY";
    /**
     * NCR integration specific to the "Quality Dining" BK franchise group.
     */
    PosVendor["QDI"] = "QDI";
    /**
     * Panasonic iQTouch Beyond POS (aka QST).
     */
    PosVendor["QST"] = "QST";
    /**
     * Xenial OMNI
     */
    PosVendor["SICOM"] = "SICOM";
    /**
     * RBI Tech tablet.
     */
    PosVendor["TABLET"] = "TABLET";
    /**
     * Xenial XOO general purpose integration (non-Carrols).
     */
    PosVendor["XENIAL"] = "XENIAL";
    /**
     * Toast POS - https://doc.toasttab.com/doc/main/index.html
     */
    PosVendor["TOAST"] = "TOAST";
})(PosVendor || (exports.PosVendor = PosVendor = {}));
//# sourceMappingURL=pos-vendor.js.map